import { render } from "./LesPelerinagePage.vue?vue&type=template&id=b9c674b0"
import script from "./LesPelerinagePage.vue?vue&type=script&lang=js"
export * from "./LesPelerinagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__